
export const partners = [
    'Crecea', 'Apropros', 'Joblife', 'Malmberg'
] as const;
export type Partner = typeof partners[number];